'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isReactNode = exports.renderIf = exports.withMark = exports.setComponentMark = exports.PropTypes = exports.checkCssVersion = exports.withDecorate = exports.genDecorate = exports.formatProps = exports.globalProps = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileoverview react相关
                                                                                                                                                                                                                                                                               * @author kirkzheng
                                                                                                                                                                                                                                                                               */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../array/index');

var _index2 = require('../type/index');

var _index3 = require('../browser/index');

var _globalProps2 = require('./global-props');

var _globalProps3 = _interopRequireDefault(_globalProps2);

var _formatProps2 = require('./format-props');

var _formatProps3 = _interopRequireDefault(_formatProps2);

var _withDecorate2 = require('./with-decorate');

var _withDecorate3 = _interopRequireDefault(_withDecorate2);

var _checkCssVersion2 = require('./check-css-version');

var _checkCssVersion3 = _interopRequireDefault(_checkCssVersion2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 用于设置组件全局属性
var globalProps = exports.globalProps = _globalProps3.default;
// 将一定格式的props数据转化成defaultProps, propTypes
var formatProps = exports.formatProps = _formatProps3.default;
// 装饰器生成方法
var genDecorate = exports.genDecorate = _withDecorate3.default;
// 高阶函数用with开头
var withDecorate = exports.withDecorate = _withDecorate3.default;
// 检查生效的css版本
var checkCssVersion = exports.checkCssVersion = _checkCssVersion3.default;

var versionList = _react2.default.version.split('.') || [];
// https://reactjs.org/blog/2017/04/07/react-v15.5.0.html#migrating-from-react.proptypes
var PropTypes = exports.PropTypes = versionList[0] > 15 || versionList[0] === 15 && versionList[1] >= 5 ? _propTypes2.default : _react2.default.PropTypes;

/**
 * 设置组件标记
 * @param {Function} componentClass 组件的类
 * @param {Object} config 信息配置
 * @param {String} config.name 组件名称
 * @param {String} config.version 组件版本
 * @param {Function} callback 设置完成后回调
 */
var haveOsName = false;
var setComponentMark = exports.setComponentMark = function setComponentMark() {
    var componentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var callback = arguments[2];
    var _config$componentName = config.componentName,
        componentName = _config$componentName === undefined ? '' : _config$componentName,
        _config$name = config.name,
        name = _config$name === undefined ? '' : _config$name,
        _config$componentVers = config.componentVersion,
        componentVersion = _config$componentVers === undefined ? '' : _config$componentVers,
        _config$version = config.version,
        version = _config$version === undefined ? '' : _config$version,
        _config$description = config.description,
        description = _config$description === undefined ? '' : _config$description;

    var _name = name || componentName || '';
    var _version = version || componentVersion || '';
    var osName = (0, _index3.getOSName)();
    var $html = null,
        htmlClassNameList = [],
        osClassName = '';

    // 在html上添加os Name
    if (osName && !haveOsName && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document && document.getElementsByTagName) {
        osClassName = 'spaui-os-' + osName.toLowerCase();
        $html = document.documentElement;

        if ($html) {
            htmlClassNameList = $html.className.split(' ');
            if ((0, _index.indexOf)(htmlClassNameList, osClassName) < 0) {
                htmlClassNameList.push(osClassName);
                $html.className = htmlClassNameList.join(' ');
                haveOsName = true;
            }
        }
    }

    if (componentClass) {
        // 组件标记
        if (_name) {
            componentClass.componentName = _name;
            componentClass._name = _name;
        }

        if (_version) {
            componentClass.componentVersion = _version;
            componentClass._version = _version;
        }

        if (description) {
            componentClass.componentDescription = description;
            componentClass._description = description;
        }
    }

    if ((0, _index2.isFunction)(callback)) {
        callback(config);
    }

    return componentClass;
};
// 高阶函数用with开头
var withMark = exports.withMark = setComponentMark;

/**
 * 根据条件判断是否渲染
 * @param {Boolean} bool 条件
 * @param {Any} trueComponentInstance true的时候组件的实例
 * @param {Any} falseComponentInstance false的时候组件的实例
 * @returns {Any} trueComponentInstance or falseComponentInstance
 */
var renderIf = exports.renderIf = function renderIf() {
    var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var trueComponentInstance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var falseComponentInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    return bool ? trueComponentInstance : falseComponentInstance;
};

// 判断该节点是否是 ReactNode
var isReactNode = exports.isReactNode = function isReactNode(node) {
    return _react2.default.isValidElement(node) || (0, _index2.isArray)(node) || typeof node === 'string' || typeof node === 'number' || typeof node === 'boolean' || (typeof node === 'undefined' ? 'undefined' : _typeof(node)) === undefined || node === null;
};

exports.default = {
    PropTypes: PropTypes,
    globalProps: globalProps,
    formatProps: formatProps,
    genDecorate: genDecorate,
    withDecorate: withDecorate,
    checkCssVersion: checkCssVersion,
    setComponentMark: setComponentMark,
    withMark: withMark,
    renderIf: renderIf,
    isReactNode: isReactNode
};